import { createFileRoute } from '@tanstack/react-router'
import SettingsAppearance from '@/features/settings/appearance'

export const Route = createFileRoute('/_authenticated/_sidebar/settings/appearance')({
	component: SettingsAppearance,
})
